import React from 'react';
import DataGrid from 'components/DataGrid/DataGrid';

import historyColumnConfig from './historyColumnConfig';

class History extends React.Component {
  render() {
    return (
      <div>
        <DataGrid
          refreshOnFetch={true}
          actions={false}
          paginationTop={true}
          paginationBottom={false}
          export={false}
          minRows={18}
          url="/entity-logs"
          role="ORDER"
          columns={historyColumnConfig}
          manipulateQuery={(requestData, query) => {
            query['associatedClient.id[]'] = this.props.userId;
            query['associatedClient.id[_operator]'] = 'eq';

            return query;
          }}
        />
      </div>
    );
  }
}

export default History;
